import { DATE_FORMAT } from './constants';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

export const formatDate = (date: string, time = '00:00', formatOutput = DATE_FORMAT) => {
	const parsedDate = date.replace(/T.*/, '');

	return format(new Date(`${parsedDate}T${time}`), formatOutput, { locale: ptBR });
};
